<template>
  <div class="my-dashboard d-print-none py-3 d-lg-none d-sm-block">
    <b-row align-v="center">


      <b-icon-person class="img-fluid h1 ml-auto mr-auto rounded text-center rounded-circle "
                     v-if="$store.getters['User/getProfile'].image == null"/>
      <img v-else class="img-fluid h1   rounded text-center rounded-circle profile-image"
           :src="$store.getters['User/getProfile'].image" alt="profile">
      <span class="d-print-none mr-2">   {{
          `${$store.getters['User/getProfile'].name} ${$store.getters['User/getProfile'].last_name}`
        }}
             <widget-wallet/>
        </span>


    </b-row>

  </div>
</template>

<script>
import WidgetWallet from "../../components/dashboard/Wallet/WidgetWallet";

export default {
  name: "DashboardMobileProfile",
  components:{WidgetWallet},
}
</script>

<style scoped>
.profile-image {
  height: 60px;
  width: 75px;
  object-fit: contain;
}
</style>